module.exports = __webpack_public_path__ + "img/money.977353e1.webp";